import { useEffect, useMemo, useState } from "react";
import api from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import { Calendar } from "@/components/ui/calendar";
import { Card } from "@/components/ui/card";

function toISO(d) {
  if (!d) return "";
  const p = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
}

export default function TeerCalendar() {
  const [month, setMonth] = useState(new Date());
  const [selected, setSelected] = useState(new Date());
  const [items, setItems] = useState([]);

  const monthKey = useMemo(() => {
    const p = (n) => String(n).padStart(2, "0");
    return `${month.getFullYear()}-${p(month.getMonth() + 1)}`;
  }, [month]);

  useEffect(() => {
    api
      .get("/results/dates", { params: { month: monthKey } })
      .then((r) => setItems(r.data.items))
      .catch(() => setItems([]));
  }, [monthKey]);

  const map = useMemo(() => {
    const m = {};
    for (const it of items) m[it.date] = it;
    return m;
  }, [items]);

  const selectedISO = toISO(selected);
  const sel = map[selectedISO];

  const modifiers = {
    hasResult: items.map((it) => {
      const [y, m, d] = it.date.split("-").map(Number);
      return new Date(y, m - 1, d);
    }),
  };

  return (
    <>
      <PageHeader title="Teer Calendar" subtitle="Browse results by date" />
      <div className="max-w-xl mx-auto w-full px-4 pb-10 space-y-4">
        <Card className="p-2 sm:p-3 border-slate-200 flex justify-center">
          <Calendar
            mode="single"
            selected={selected}
            onSelect={(d) => d && setSelected(d)}
            month={month}
            onMonthChange={setMonth}
            modifiers={modifiers}
            modifiersClassNames={{
              hasResult:
                "relative after:content-[''] after:absolute after:bottom-1 after:left-1/2 after:-translate-x-1/2 after:h-1 after:w-1 after:rounded-full after:bg-emerald-500",
            }}
          />
        </Card>

        <Card className="p-5 border-slate-200">
          <div className="text-[10px] font-bold uppercase tracking-widest text-slate-400 mb-1">
            {selectedISO}
          </div>
          {sel ? (
            <div className="grid grid-cols-2 gap-4">
              <div>
                <div className="text-xs font-semibold text-slate-500 uppercase">First Round</div>
                <div className="font-numbers font-black text-4xl text-slate-900 mt-1">
                  {String(sel.r1 || "--").padStart(2, "0")}
                </div>
              </div>
              <div>
                <div className="text-xs font-semibold text-slate-500 uppercase">Second Round</div>
                <div className="font-numbers font-black text-4xl text-slate-900 mt-1">
                  {String(sel.r2 || "--").padStart(2, "0")}
                </div>
              </div>
            </div>
          ) : (
            <div className="text-slate-500 text-sm">No result published for this date.</div>
          )}
        </Card>
      </div>
    </>
  );
}
